import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import { Route, Routes } from "react-router";
import { Permission } from "./ProtectRoute/permissionRoutes";
import ScanLoader from "./img/Document scan.gif";
import PageNotFound from "./Pages/Modules/PageNotFound/PageNotFound";
const ChangePassword = lazy(
  () => import("./Pages/Modules/Auth/UserProfile/changePassword"),
);
const Login = lazy(() => import("./Pages/Modules/Auth/LoginPage"));
const ForgotPassword = lazy(
  () => import("./Pages/Modules/Auth/ForgotPassword"),
);
const ResetPassword = lazy(() => import("./Pages/Modules/Auth/ResetPassword"));
const HomePage = lazy(() => import("./Pages/HomePage/HomePage"));

const App = () => {
  const { LoginPermission, AllPermission, ClientPermission } = Permission;

  const [resizingColumn, setResizingColumn] = useState(null);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const tableRef = useRef(null);

  useEffect(() => {
    const onMouseMove = (e) => {
      if (resizingColumn !== null) {
        const width = startWidth.current + (e.pageX - startX.current);
        const table = tableRef.current;

        if (!table) {
          console.error("Table reference is null.");
          return;
        }

        const th = table.querySelector(`th:nth-child(${resizingColumn + 1})`);

        if (!th) {
          console.error(
            `No th element found for column index: ${resizingColumn}`,
          );
          return;
        }

        th.style.width = `${width}px`;
        table.classList.add("resizing");
      }
    };

    const onMouseUp = () => {
      setResizingColumn(null);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    if (resizingColumn !== null) {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [resizingColumn]);

  const onMouseDown = (e, columnIndex) => {
    setResizingColumn(columnIndex);
    startX.current = e.pageX;
    startWidth.current = e.target.offsetWidth;
    document.body.style.userSelect = "none";
    tableRef?.current?.querySelectorAll("th")?.forEach((column, index) => {
      if (index !== columnIndex) {
        column.style.width = `${column.offsetWidth}px`;
      }
    });
  };
  return (
    <>
      <Suspense
        fallback={
          <div
            className="hstack justify-content-center"
            style={{ height: "100vh" }}
          >
            <img
              src={ScanLoader}
              alt="Loadeer"
              style={{ height: 200, width: 200 }}
            />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<AllPermission />}>
            <Route path="/" element={<Login />} />
          </Route>

          <Route path="/login" element={<LoginPermission />}>
            <Route path="/login" element={<Login />} />
          </Route>

          <Route path="/forgotPassword" element={<LoginPermission />}>
            <Route path="/forgotPassword" element={<ForgotPassword />} />
          </Route>

          <Route path="/resetPassword" element={<LoginPermission />}>
            <Route path="/resetPassword" element={<ResetPassword />} />
          </Route>

          <Route path="/changePassword" element={<AllPermission />}>
            <Route path="/changePassword" element={<ChangePassword />} />
          </Route>

          <Route path="/home" element={<ClientPermission />}>
            <Route
              path="/home"
              element={
                <HomePage tableRef={tableRef} onMouseDown={onMouseDown} />
              }
            />
          </Route>

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
